import { render } from "./home-fivebanner.vue?vue&type=template&id=1083f638"
import script from "./home-fivebanner.vue?vue&type=script&lang=js"
export * from "./home-fivebanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__